export enum FatcaTypeEntity {
    A1 = '1F',
    A2 = '2F',
    B = '3F',
    C = '4F',
    D = '5F',
    E = '6F',
    F = '8F',
    G = '9F'
}
